import { AsyncState, loadingAsyncState } from "widgets-for-react"
import { fetchEmbed } from "./ThemakiezerBlockApi"
import { CollectionItem } from "../../../custom_api/generated"

export interface ThemakiezerBlockProps {
  embedId: string
  title?: string
  text?: string
}

export interface ThemakiezerBlockState {
  books: AsyncState<CollectionItem[]>
}

export const initialThemakiezerBlockState = (props: ThemakiezerBlockProps): ThemakiezerBlockState => ({
  books: loadingAsyncState(fetchEmbed(props.embedId))
})
